import { Typography } from "../../../../../core/components/molecules/Typography";
import { Icon } from "../../../../../core/components/atoms/Icon";
import { getDisciplineName } from "../../../../../core/utils/discipline";

interface IDisciplineReportCarouselItem {
  discipline: string;
  progress: number;
  icon: { type: 'svg' | 'material', Icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | string };
  doneItems: { type: 'exercises' | 'lessons' | 'materials' | 'essays', value: number }[];
} 

const DisciplineReportCard: React.FC<IDisciplineReportCarouselItem> = ({ discipline, progress, icon, doneItems }) => {
  return (
    <div className={`bg-disciplina-${discipline} rounded-lg p-4`}>
      <div className="flex flex-row justify-between items-center">
        <div className="flex flex-row items-center gap-sm">
          <Icon Icon={icon.Icon} type={icon.type} className="text-mono-color-white w-[24px] h-[24px]" />
          <Typography weight="bold" className="text-[#fff]"> {getDisciplineName(discipline)} </Typography>
        </div>
        <Typography size="mini" className="text-[#fff]"> {progress.toFixed(2)}% concluída </Typography>
      </div>
      <div className="h-1 w-full bg-[#000000]/20 rounded-pill mt-3">
        <div className="h-full bg-mono-color-white rounded-pill" style={{ width: `${progress}%` }} />
      </div>
        <div className="flex flex-row justify-between items-center mt-6">
          {discipline === 'redacao' ? (
            <div className="flex flex-col gap-1">
              <Typography className="text-[#fff] flex flex-row items-center gap-sm"> 
                <Icon Icon="edit" type="material" className="text-[#fff] text-[16px]" />
                <b>{doneItems.find((item) => item.type === 'essays')?.value}</b>
              </Typography>
              <Typography size="mini" className="text-[#fff]"> 
                Redações<br/> enviadas
              </Typography>
            </div>
          ) : (
            <div className="flex flex-col gap-1">
              <Typography className="text-[#fff] flex flex-row items-center gap-sm"> 
                <Icon Icon="edit" type="material" className="text-[#fff] text-[16px]" />
                <b>{doneItems.find((item) => item.type === 'exercises')?.value}</b>
              </Typography>
              <Typography size="mini" className="text-[#fff]"> 
                Exercícios<br/> resolvidos
              </Typography>
            </div>
          )}
          <div className="flex flex-col gap-1">
            <Typography className="text-[#fff] flex flex-row items-center gap-sm"> 
              <Icon Icon="play_circle" type="material" className="text-[#fff] text-[16px]" />
              <b>{doneItems.find((item) => item.type === 'lessons')?.value}</b>
            </Typography>
            <Typography size="mini" className="text-[#fff]"> 
              Videoaulas<br/> assistidas
            </Typography>
          </div>
          <div className="flex flex-col gap-1">
            <Typography className="text-[#fff] flex flex-row items-center gap-sm"> 
              <Icon Icon="library_books" type="material" className="text-[#fff] text-[16px]" />
              <b>{doneItems.find((item) => item.type === 'materials')?.value}</b>
            </Typography>
            <Typography size="mini" className="text-[#fff]"> 
              Materiais<br/> acessados
            </Typography>
          </div>
        </div>
      </div>
  );
};

export default DisciplineReportCard;